export const rootDomain = process.env.GATSBY_EXTERNAL_DATA_API_URL;
export const storyblokRootDomain = process.env.GATSBY_STORYBLOK_DATA_API_URL;

export interface RocheEndpoint<T> {
  Total: number;
  Page: number;
  Items: T;
}

export interface RochePipelineEndpoint<T> {
  Items: T[];
}
